import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Typography,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";

import cssVariables from "../../theme/cssVariables";

import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import personImg from "../../assets/icons/person-fill.svg";


import * as Util from "../../services/global.service";

const useStyles = makeStyles({
  media: {
    height: 200,
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  paperDetailContainer: {
    backgroundColor: `${cssVariables.color.gray}!important`,
    width: "100%",
    padding: "1.5rem",
  },
  blueBg: {
    background: "#6694CC",
  },
  profileContainer: {
    width: 60,
    height: 60,
    borderRadius: "50%",
    marginTop: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  statusBadge: {
    width: "150px",
    borderRadius: "5px",
    padding: "8px 10px",
    textAlign: "center",
  },
  draftBg: {
    background: "#EFB76D26"
  },
  draftText: {
    color: "#EFB76D"
  },
  pendingBg: {
    background: "#F280261A"
  },
  pendingText: {
    color: "#EFB76D"
  },
  approveBg: {
    background: "#5DA19626"
  },
  approveText: {
    color: "#5DA196"
  },
  rejectedBg: {
    background: "#CC605826"
  },
  rejectedText: {
    color: "#CC6058"
  },
  grayBg: {
    background: "#82828226"
  },
  grayText: {
    color: "#828282!important",
  },
  cancelBg: {
    background: "#CC605826"
  },
  cancelText: {
    color: "#CC6058",
  },
  cancelPendingBg: {
    background: "#82828226"
  },
  cancelPendingText: {
    color: "#828282",
  },
  grayStepBg: {
    background: "#828282",
  },
  stepTextRoot: {
    fill: "#939393!important"
  },
  processBg: {
    background: "rgba(239, 183, 109, 0.15)",
  },
  completedBg: {
    background: "rgba(93, 161, 150, 0.15)",
  },
  redBg: {
    background: "rgba(204, 96, 88, 0.15)",
  },
  processText: {
    color: "#EFAD0A!important",
  },
  completedText: {
    color: "#5DA196!important",
  },
  redText: {
    color: "#CC6058!important",
  },
  paddingRight_8: {
    paddingRight: "8px",
  },
  paddingRight_0: {
    paddingRight: "0!important",
  },
  disabledSvg: {
    "& > path": {
      fill: "#A0A0A0",
    },
    "& g > path": {
      fill: "#A0A0A0",
    },
  },
});

const ReadMoreDialog = (props) => {
  const { t } = useTranslation();
  const language = localStorage.getItem("lang");
  const handleClose = () => {
    props.setValue(false);
  };

  const classes = useStyles();

  return (
    <React.Fragment>
      <Dialog
        onBackdropClick={() => { return false }}
        open={props.open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="form-add-dialog-title" fontSize="1.3rem">
          {props.title}
          <Box
            sx={{
              position: "absolute",
              right: 0,
              margin: "15px 18px 0  0",
              top: 0,
            }}
            className="clickable"
            onClick={handleClose}
          >
            <img src={CloseIcon} alt="browser" />
          </Box>
          <Divider sx={{ marginTop: "10px" }} />
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              flexFlow: "column",
            }}
          >
            <Grid container>
              <Grid item xs sm md lg>
                <Grid container spacing={2}>
                  <Grid
                    item
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    {
                      props?.data?.profileImage ?? false ?
                        <img
                          className={`${classes.profileContainer}`}
                          src={props?.data?.profileImage ?? "/exam-profile.png"}
                          alt="profile"
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = personImg;
                          }}
                        /> : <Avatar className={`${classes.profileContainer}`} />
                    }
                  </Grid>
                  <Grid item xs sm>
                    <Grid container py={1}>
                      <Grid item xs sm>
                        <Grid container>
                          <Grid item display="flex">
                            <Typography
                              variant="h3"
                              sx={{ marginTop: "auto" }}
                              color="#404349"
                            >
                              {props?.type === "feedback" ? t('label.feedbackGiver') : props?.data?.employee_position === "requester" ? language === "en-US" ? Util.upperFirstWord(props?.data?.employee_position) : "ผู้ส่งคำขออนุมัติ" : props?.data?.employee_position}

                            </Typography>
                          </Grid>
                          <Grid item ml="auto" xs="auto" sm="auto">
                            <div
                              className={`${classes.statusBadge} ${classes[Util.StepStatusColor(props.data) + 'Bg']}`}
                            >
                              <Typography
                                className={`${classes[Util.StepStatusColor(props.data) + 'Text']}`}
                                fontWeight={500}
                                variant="h6"
                              >
                                {props?.data?.status_name ?? "-"}
                              </Typography>
                            </div>
                          </Grid>
                        </Grid>
                        <Grid container mt={1}>
                          <Grid item xs="auto" sm="auto">
                            <Typography variant="label">
                              {language === "en-US" ? props?.data?.fullname_en : props?.data?.fullname_th}
                            </Typography>
                          </Grid>
                          <Grid item ml="auto">
                            <Typography
                              variant="sub_label"
                              color="black"
                              fontSize={14}
                            >
                              {Util.dateDayTimeFormat(props?.data?.date) ?? "-"}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {((props?.data?.proxy !== undefined && props?.data?.proxy !== "") || (props?.data?.submitted_by !== undefined && props?.data?.submitted_by !== "")) &&
              <Box sx={{ width: "100%", background: "#FAFAFA", "border-radius": "4px", padding: "3px 8px", margin: "10px 0px" }} >

                {(props?.data?.submitted_by !== undefined && props?.data?.submitted_by !== "") &&
                  <Typography fontSize={14} lineHeight="28px" > {"Submitted by:"} <span style={{ color: '#5DA196' }}>{Util.formatData(language === "en-US" ? props?.data?.submitted_by?.fullname_en : props?.data?.submitted_by?.fullname_th, "-")}</span></Typography>
                }

                {(props?.data?.proxy !== undefined && props?.data?.proxy !== "") &&
                  <Typography fontSize={14} lineHeight="28px" > {"Proxy by:"} <span style={{ color: '#5DA196' }}>{Util.formatData(props?.data?.proxy, "-")}</span></Typography>
                }
              </Box>
            }

            <Typography fontWeight="600" color="#404349">{t("inbox.label.comment")}:</Typography>
            <Box sx={{ width: "100%" }}>
              <TextField
                multiline
                rows={4}
                margin="dense"
                id="description"
                value={props?.data.comment ?? ""}
                fullWidth
                InputProps={{ readOnly: true, disableUnderline: true }}
                size="large"
              />
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 20,
          }}
        >
          <Button
            onClick={handleClose}
            size="medium"
            variant="contained"
            sx={{ width: "150px", color: "#fff!important" }}
            color="primary"
          >
            {t("label.close")}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default ReadMoreDialog;
